export const videoEvents = [
    'loadstart',
    'suspend',
    'abort',
    'error',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'canplay',
    'canplaythrough',
    'playing',
    'waiting',
    'seeking',
    'seeked',
    'ended',
    'durationchange',
    'timeupdate',
    'progress',
    'play',
    'pause',
    'ratechange',
    'volumechange'
];


// WEBPACK FOOTER //
// /Users/gebb/Desktop/live/modules/f.component.ad.mobile/app/modules/AdCore/videoEvents.js